<template>
  <!-- 成绩列表 弹窗：重批 -->
    <el-dialog :title="reprintTextConfig.title" v-if="dialogVisible" :visible.sync="dialogVisible" width="500px" @close="close"
               :close-on-click-modal="false" :close-on-press-escape="false">
        {{ reprintTextConfig.tip }}
        <el-table :data="tableData" v-loading="loading" element-loading-text="加载中"
                  element-loading-spinner="el-icon-loading" ref="multipleTable"
                  @selection-change="handleSelectionChange" stripe size="medium" style="width:100%">
            <el-table-column type="selection" width="48" fixed="left" align="center"
                             :selectable="checkSelectable"></el-table-column>
            <el-table-column prop="number" :label="reprintTextConfig.number">
                <template slot-scope="scope">{{ scope.row.reviewer.questionSort }}</template>
            </el-table-column>
            <el-table-column :label="reprintTextConfig.teacherId">
                <template slot-scope="scope">{{ findTeacherName(scope.row.reviewer.teacherId) }}</template>
            </el-table-column>
            <el-table-column prop="score" :label="reprintTextConfig.score"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">{{ reprintTextConfig.cancel }}</el-button>
            <el-button type="primary" @click="submitForm()" :disabled="selectRow.length===0">{{ reprintTextConfig.ok }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: ['row', 'show'],
    data() {
        return {
            loading: true,
            dialogVisible: false,
            selectRow: [],
            tableData: [],
            teacherList: []
        };
    },
    computed: {
        reprintTextConfig() {
            return this.$store.state.global.textConfig.backend.examineeScore.table.button.reprint
        }
    },
    watch: {
        show() {
            this.dialogVisible = this.show;
            this.loading = true
            this.selectRow = []
            if (this.show) {
                this.$store.dispatch('getReviewer', this.row).then(res => {
                    if (res.status === 200) {
                        this.loading = false
                        this.tableData = res.data
                    }
                })
                this.teacherList = this.$store.state.reviewTeacherList.list
            }
        },
    },
    methods: {
        findTeacherName(id) {
            let obj = {}
            obj = this.teacherList.find(item => {
                return item.teacherId == id
            })
            if (obj) {
                return obj.teacherName
            }
        },
        checkSelectable(row) {
            return row.questionReviewStatus === 1
        },
        handleSelectionChange(val) {
            this.selectRow = []
            for (let i = 0; i < val.length; i++) {
                const e = val[i];
                this.selectRow.push(e)
            }
        },
        close() {
            this.dialogVisible = false
            this.$emit('close', false)
        },
        submitForm() {
            let ids = []
            for (let i = 0; i < this.selectRow.length; i++) {
                const e = this.selectRow[i].id;
                ids.push(e)
            }
            this.$store.dispatch('putReviewAgain', ids).then(res => {
                if (res.status === 200) {
                    this.$message({type: 'success', message: this.reprintTextConfig.success});
                    this.$parent.search(1)
                }
                this.close()
            })
        }
    }
}
</script>
